import 'leaflet'
import 'leaflet.markercluster'
import 'leaflet.featuregroup.subgroup'
import Semafor from "../../Semafor"

class SubLayer {
  popupCreator = null
  getMarkerIcon = null
  maxCount = 30000
  chunkSize = 15000
  chunkDelay = 200
  destroyAsync = false
  useSemafor = true
  vm = null
  opts = {}
  _data = []

  constructor (map, config, opts = {vm: null, popupCreator: null}) {
    this.opts = opts
    this.popupCreator = opts.popupCreator
    this.vm = opts.vm

    this.shown = false;
    this._map = map;
    this.semafor = new Semafor()
    this.lockId = Semafor.getLockId()
    this.parseConfig(config);
    this.listenDestroyMap()
  }

  listenDestroyMap () {
    this.vm.$emitter.listen('geo.destroyMap', () => {
      this.destroyAsync = true
      this.useSemafor === true && this.semafor.onlyUnlock(this.lockId)
      if (this.notify && typeof this.notify.close !== "undefined") {
        this.notify.close()
      }
    })
  }

  remove () {
    if (this.layer) {
      this.layer.clearLayers()
    }
  }

  parseConfig (config) {
    this.config = config;
    if (config.parent) {
      this.parent = config.parent;
    }
    if (config.id) this.id = config.id;
    this.checkbox = config.checkbox;
  }

  async show () {
    if (!this._data) {
      console.error('No data found')
      return false;
    }

    this.shown = true;
    if (!this.layer) {
      let startedAt = +new Date()
      this.layer = this.config.layer;
      if (this.useSemafor === true && this.semafor.hasLock() === true) {
        await this.semafor.waitForUnlock(this.lockId)
      }
      console.log('unlocked', this)
      this.useSemafor === true && this.semafor.lock(this.lockId)
      for (let i = 0; i < this._data.length; i++) {
        if (this.destroyAsync) {
          console.warn('destroyAsync')
          break
        }
        let item = this._data[i]
        if (item.lat && item.lng) {
          let marker = L.marker([item.lat, item.lng], {
            icon: this.config.getMarkerIcon(
              this.config.subLayerConfig.iconType,
              this.config.layerConfig.iconType,
              item
            )
          })
            .addTo(this.layer)
            .on('click', (e) => {
              this.bindPopup(e.target);
            });
          marker._info = item;
          if (this.vm.popupIsOpened(marker._info)) {
            this.checkForOpenMarker(marker)
          }
        } else {
          console.error('Unknown lat, lng in marker ', item)
        }
        if (i === this.maxCount) {
          this.layer.addTo(this._map);
          try {
            let warningAt = +new Date()
            await this.showMaxCountWarningBox(i, this._data.length, startedAt, warningAt)
          } catch (e) {
            this.useSemafor === true && this.semafor.unlock(this.lockId)
            console.warn('break on cancel')
            break
          }
        } else if (i > this.maxCount && i % this.chunkSize === 0) {
          await new Promise(resolve => {
            this.vm.$bar.startOrContinue()
            setTimeout(() => {
              resolve()
            }, this.chunkDelay)
          })
        }
      }
      this.vm.$bar.finish()
      this.useSemafor === true && this.semafor.unlock(this.lockId)
    }
    this.layer.addTo(this._map);
  }

  checkForOpenMarker (openedMarker) {
    setTimeout(() => {
      if (openedMarker) {
        // console.log('try to open', openedMarker)
        // detect if marker in cluster
        if (openedMarker.__parent && openedMarker.__parent._childCount && openedMarker.__parent._group) {
          // open cluster
          openedMarker.__parent._group.zoomToShowLayer(openedMarker, () => {
            openedMarker.fire('click')
          })
        } else {
          openedMarker.fire('click')
        }
      }
    }, 0)
  }

  registerOpenPopupInVue(markerInfo) {
    this.vm.registerOpenPopup(markerInfo)
  }

  popupIsOpened(markerInfo) {
    return this.vm.popupIsOpened(markerInfo)
  }

  bindPopup(marker) {
    let popup;
    if (!marker._popup) {
      popup = this.popupCreator.getPopup(marker, 'default', marker._info.id, {
        autoPan: true,
        layerConfig: this.config.layerConfig,
        subLayerConfig: this.config.subLayerConfig,
        id: marker._info.id
      })
      marker.bindPopup(popup).openPopup()
    }
    this.vm.registerOpenPopup(marker._info)
  }

  hide() {
    this.shown = false;
    if (this.layer) {
      this.layer.remove();
    }
  }

  toggle() {
    if (this.shown) {
      this.hide();
    } else {
      this.show();
    }
  }

  showMaxCountWarningBox (showed, total, startAt, warningAt) {
    return new Promise((resolve, reject) => {
      let overheadCoef = 5
      let delay = warningAt - startAt
      let pointDrawSpeed = showed / delay
      let fastTime = (((total - showed) / pointDrawSpeed) / 1000)
      let fastTimeSec = Math.ceil(fastTime * overheadCoef)
      let chunkBreakTime = (((total - showed) / this.chunkSize) * this.chunkDelay) / 1000
      let slowTime = fastTime + chunkBreakTime
      let slowTimeSec = Math.ceil(slowTime * overheadCoef)
      console.log(startAt, warningAt, pointDrawSpeed, fastTime, slowTime, chunkBreakTime)
      console.log(fastTimeSec, slowTimeSec)
      let isConfirmed = false
      let name = this.config.subLayerConfig.label
      this.notify = this.vm.$notify.warning({
        position: 'top-left',
        type: 'success',
        title: `Отображено ${showed} из ${total} точек типа ${name}`,
        message: `
          <p>Дальнейшее отображение может вызвать проблемы с 
          производительностью вашего компьютера (например зависание).</p>
          <p>Если у вас мощный компьютер нажмите продолжить, отрисовка займет ~${slowTimeSec} сек.</p>
          <p style="text-align: center">
             <button
             type="button"
             class="actions-filter-panel__button standart confinue"
             >
             Продолжить
             </button>
          </p>
          `,
        dangerouslyUseHTMLString: true,
        duration: 0,
        onClose: () => {
          setTimeout(() => {
            isConfirmed === false && reject(false)
          }, 200)
        }
      })
      console.log('showMaxCountWarningBox', this)
      setTimeout(() => {
        const continueBtn = this.notify.$el && this.notify.$el.querySelector('.confinue')
        continueBtn && continueBtn.addEventListener('click', (evt) => {
          evt.preventDefault()
          evt.stopPropagation()
          isConfirmed = true
          this.notify.close()
          this.vm.$bar.startOrContinue()
          setTimeout(() => {
            resolve(true)
          }, 200)
        })
      }, 0)
    })
  }
}

export default SubLayer
